import React, { useEffect, useState } from "react";
import DeviceUsersTable from "./components/DeviceUsersTable";
import Divider from "@material-ui/core/Divider/index";
import axios from "axios";
import { useSelector } from "react-redux";
import Users from "./modals/Users";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import Filter from "./modals/Filter";
import { updateObject } from "../../../helpers/updateObject";
import { AiOutlineFileSearch } from "react-icons/ai";
import { Tooltip } from "@material-ui/core";

function DeviceUsers(props) {
  const token = useSelector((state) => state.auth.token);
  const permissionList = useSelector(state => state.auth.permissionList)

  const [deviceUsers, setDeviceUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteDeviceUsersIds, setDeleteDeviceUsersIds] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [showUsers, setShowUsers] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [filterInputs, setFilterInputs] = useState({
    pin: "",
  });

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onDeviceUsers = (orderBy, sortField, skip, take) => {
    setIsLoading(true);
    const { pin } = filterInputs;
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }device-user?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${
          pin ? `&pin=${pin}` : ""
        }`,
        {
          headers: { Authorization: `bearer ${token}` },
        }
      )
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setDeviceUsers(content);
        setIsError(false);
        setCount(totalElements);
      })
      .catch(() => {
        setIsLoading(false);
        setDeviceUsers([]);
        setIsError(true);
      });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onDeviceUsers(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Qurğudakı Əməkdaşlar </h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
         { permissionList.some(element => element === "search_device_user") && 
        <div className=" col-1 d-flex justify-content-end">
          <Tooltip title="Search" placement="top">
            <button
              className="btn btn-sm btn-icon btn-bg-light btn-text-success btn-hover-success mr-2 h5 rounded-circle flex-shrink-0"
              onClick={() => setShowUsers(true)}
            >
              <AiOutlineFileSearch />
            </button>
          </Tooltip>
        </div>}
      </div>

      <Divider className="w-100" />
      <DeviceUsersTable
        deviceUsers={deviceUsers}
        isLoading={isLoading}
        isError={isError}
        setDeleteDeviceUsersIds={setDeleteDeviceUsersIds}
        deleteDeviceUsersIds={deleteDeviceUsersIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        setShowUsers={setShowUsers}
      />

      {showUsers && <Users show={showUsers} onHide={setShowUsers} />}

      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
      />
    </div>
  );
}

export default DeviceUsers;
